import React from 'react';
import { Column, Row } from 'components/Layout/Grid';
import Animated from 'components/Animated';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from 'store/ducks';
import Text from 'components/Text';
import { Button } from 'components/Button';
import { ActionButton } from 'components/ModelButton';
import '../../pages/Quotes/styles.scss';

const BlockedItemToast: React.FC = () => {
  const blockedToast = useSelector((state: RootState) => state.blockedItemToast);
  const blockedDispatch = useDispatch();

  return (
    <Animated
      className="d-flex fixed top-0 right-0 left-0 bottom-0 bg-modal align-center justify-center"
      animationIn="fadeIn"
      animationInDelay="faster"
      animationOut="fadeOut"
      animationOutDelay="faster"
      show={blockedToast?.show}
      style={{ zIndex: 9999999 }}
    >
      <Animated
        animationIn="slideInDown"
        animationInDelay="faster"
        animationOut="slideOutUp"
        animationOutDelay="faster"
        show={blockedToast?.show}
      >
        <Column
          className="bg-white p-4"
          style={{ width: 420, borderRadius: 10 }}
        >
          {blockedToast?.title && (
            <Text
              className="color-blue-gray font-bold text-wrap mt-5 text-center"
              size={16}
            >
              {blockedToast.title}
            </Text>
          )}
          {blockedToast?.additionalInformation && (
            <Text
              className="color-alert font-bold text-wrap mt-2 text-center"
              size={16}
            >
              {blockedToast.additionalInformation}
            </Text>
          )}
          <Text
            className={`color-blue-gray text-wrap ${blockedToast?.title !== undefined ? '' : 'mt-2'
              } text-center`}
            size={12}
          >
            {blockedToast?.text}
          </Text>
          <Row>
            {blockedToast?.actionButton && (
              <ActionButton
                img=""
                textButton={blockedToast?.buttonActionLabel || 'Sim'}
                className="bg-blockedButtonToast color-white mt-5 w-40 mx-auto"
                action={() => blockedToast.actionButton()}
                enableWidth={false}
                trackItem={blockedToast.trackItem}
                trackName={blockedToast.trackAction}
              />
            )}
          </Row>
          <Text
            className={`color-blue-gray text-wrap ${blockedToast?.title2 !== undefined ? '' : 'mt-5'
              } text-center`}
            size={12}
          >
            {blockedToast?.text2}
          </Text>
          <Row>
            <Button
              onClick={() => blockedDispatch({ type: 'CLOSE_BLOCKED_ITEM_TOAST' })}
              className="outline color-primary mt-5 w-40 mx-auto"
            >
              <Text className="font-bold color-white">
                {blockedToast?.buttonLabel || 'Ok'}
              </Text>
            </Button>
          </Row>
        </Column>
      </Animated>
    </Animated>
  );
};

export default BlockedItemToast;
